module.exports = __webpack_public_path__ + "static/media/amgen.9246da24.png";